import { Organization } from "./organization";

export enum InvoiceStatus {
  Pending,
  Paid,
  PastDue,
  Void
}

export type InvoicedSession = {
  user: string;
  title: string;
  start_time: Date;
  end_time: Date;
  duration: number;
};

export type InvoicedCoach = {
  name: string;
  coached_time: number;
  billed_time: number;
  unbilled_time: number;
  sessions: InvoicedSession[];
};

export type Invoice = {
  id: string;
  invoice_num: number;
  amount: number;
  status: InvoiceStatus;
  start_date: Date;
  end_date: Date;
  due: Date;
  line_items: InvoicedCoach[];
  organization_id: string;
  organization: Organization;
};
